var XPortal = XPortal || {};
XPortal.MValuePiker = (function () {
    var self = {
        controlSelector: ".data-xvalue-picker",
        controlSelectorNotInFSet: ".data-xvalue-picker:not(.dynamic-filter-set .data-xvalue-picker)",
        controlTileSelector: ".p-tile",
        Init: function (container, modelName, exceptFSets) {
            container = container ? container : $(XPortal.Main.DetialFormSelector);
            modelName = modelName || XPortal.Store.getModelName(container[0].id);
            container.find(exceptFSets ? self.controlSelectorNotInFSet : self.controlSelector).each(function (i, element) {
                XPortal.MValuePiker.initFor(element, modelName);
            });
            $(document).off("dataSource.read", self.controlSelector, updateDataSource).on("dataSource.read", self.controlSelector, updateDataSource);
        },
        GetValue: function (el, sttgs, value) {
            var r = [];
            el.find(".p-tile input:checked").each(function () {
                r.push($(this).val());
            });
            var rr = _.uniq(r, rx => (rx || "").toLowerCase());
            return rr.join(sttgs.valueSeparator);
        },
        SetValue: function (el, sttgs, value) {
            if (XPortal.DefaultEditor.IsModified(el, value)) return;
            sttgs.value = value;
            self.SetupCurrentValue(el, sttgs);
        },
        SetupCurrentValue: function (el, sttgs) {
            var mval = _.isArray(sttgs.value) ? sttgs.value : [sttgs.value];
            mval = sttgs.ismultiselect && _.isString(sttgs.value) ? sttgs.value.split(sttgs.valueSeparator) : mval;

            el.find(".p-tile").each(function () {
                var $this = $(this);
                var pel = $this.find("input[type='checkbox'], input[type='radio']");
                var pval = pel.val();
                var checked = mval.indexOf(pval) > -1;
                if (sttgs.isBoolean)
                    $.each(mval, function (ix, x) {
                        if (x == pval) checked = true;
                    });
                pel.prop("checked", checked);
            });
        },
        initFor: function (element, modelName) {
            const el = jQuery(element);
            const vElmnt = el.find("input.xpand-multiselect-val");
            const sttgs = getDataModelFor(el, vElmnt, modelName);
            self.SetupCurrentValue(el, sttgs);
            if (sttgs.editable) initChangeValueEvent(el, vElmnt, sttgs, modelName);
            const sfunction = function (e, r) { executeSearch(r, el, vElmnt, sttgs, modelName); };
            el.off("search.execute", sfunction).on("search.execute", sfunction);
            XPortal.Store.Subscribe({ Model: modelName, Field: sttgs.fieldname, Target: vElmnt },
                (value) => {
                    if (!sttgs.ismultiselect && value)
                        value = value.split(sttgs.valueSeparator)[0];

                    self.SetValue(el, sttgs, value);
                },
                (value) => self.GetValue(el, sttgs, value)
            );
        }
    };
    function getDataModelFor(el, valEl, modelName) {
        const sttgs = XPortal.Main.GetSettingsFor(valEl);
        sttgs.srctype = "json";
        sttgs.ismultiselect = el.hasClass("xpand-multiselect");
        sttgs.editable = el.attr("data-editable") == "1";
        sttgs.isBoolean = sttgs.type != null && sttgs.type.toLowerCase() == "boolean";
        const toggleModel = function () {
            toggleViewModel(this, el, sttgs);
        };
        sttgs.data = kendo.observable({ modelName, Items: [], Top: [], total: 0, mainQuery: "", pageIndex: 0, pageSize: sttgs.psize, hideDynamic:true, hideStatic: false, showCountOf: false, hideSimple: false, hideDetail: true, hideSLess: true, hideSMore: true, toggleModel, noItems: el.find(".p-tile").length ? false : true });
        kendo.bind(el, sttgs.data);
        el.data("x-settings", sttgs);
        return sttgs;
    };
    function toggleViewModel(s, el, sttgs) {
        s = s || this;
        let curr = s.hideSimple;
        XPortal.Utils.updateKendoObj(s, {
            hideSimple: !curr, hideDetail: curr, hideSMore: !curr, hideSLess: curr,
            pageSize: !curr ? 2000 : Number(sttgs.psize || 5)
        });
        updateDataSource({ target: el }, { data: {} });
    };
    function executeSearch(srequest, el, valueElement, sttgs, modelName) {
        const s = sttgs.data;     
        const onResult = $.Deferred();
        onResult.then(function (d) {
            if (srequest.onresult) srequest.onresult(d);
        });
        XPortal.Utils.updateKendoObj(s, { mainQuery: srequest.search });
        updateDataSource({ target: el }, { data: {}, onresult: onResult });
    };
    function initChangeValueEvent(el, valueElement, sttgs, modelName) {
        el.off("click.mvaluepicker", self.controlTileSelector, onTileClicked);
        el.on("click.mvaluepicker", self.controlTileSelector, onTileClicked);

        valueElement.off("change.mvaluepicker").on("change.mvaluepicker", function () {
            XPortal.DefaultEditor.SetModification(el);
            XPortal.Store.FieldEvent(valueElement, valueElement.val(), modelName, sttgs);
        });
    };
    function onTileClicked(e) {
        e.stopPropagation();
        e.preventDefault();
        const $itl = $(this);        
        const $iel = $itl.closest(self.controlSelector);
        const vElmnt = $iel.find("input.xpand-multiselect-val"), isttgs = $iel.data("x-settings") || { meta: {} };
        const isClicked = $itl.is(".clicked");
        const $inputCheckBx = $itl.find("input[type='radio'], input[type='checkbox']");
        if (isClicked) $itl.removeClass("clicked"); else $itl.addClass("clicked");
        if ($inputCheckBx.prop("checked") == isClicked)
            $inputCheckBx.prop("checked", !isClicked);

        vElmnt.val(isttgs.value = self.GetValue($iel, isttgs));
        vElmnt.trigger("change.mvaluepicker");
    };
    let validKeys = ["value", "title", "display", "imageurl"];
    function updateDataSource(e, o) {
        const $el = $(e.target);
        const sttgs = $el.data("x-settings") || { meta: {} };
        sttgs.data.set("pageSize", o.isShowAll ? 2000 : sttgs.data.pageSize);
        if (!o.data.grids) o.data.grids = sttgs.data.grids;
        o.onresult = o.onresult ? o.onresult : $.Deferred();
        o.data = Object.assign(o.data || {}, { PageIndex: sttgs.data.pageIndex, PageSize: sttgs.data.pageSize, mainQuery: sttgs.data.mainQuery, fid: sttgs.meta.fieldid, fieldname: sttgs.meta.fieldname, sid: sttgs.meta.fsetid });
        sttgs.data.grids = Object.assign([],o.data.grids);
        o.rejected = false;
        if (!sttgs.srcurl) return;
        o.headers = Object.assign(o.headers | {}, { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() });
        $el.trigger("lookup.beforeRequest", o);
        if (o.rejected) return;
        var ajaxReq = {
            method: "POST", dataType: sttgs.srctype, cache: false, contentType: 'application/json', url: XPortal.Utils.EnsureInProfile(sttgs.srcurl), data: kendo.stringify({ model: o.data }), headers: o.headers,
            success: function (xdata) {
                if (xdata.ProcessedResult) return o.onresult.resolve(xdata.ProcessedResult.Items);
                xdata.Result = xdata.Result || {};
                xdata.Result.Items = xdata.Result.Items || [];
                try {
                    xdata = XPortal.Grid.ConvertToKendoData(xdata, sttgs, {});
                } catch (ex) {
                    XPortal.Events.Profile("ERROR:" + ex.message, 1, ex);
                }
                for (var i = 0; i < xdata.length; i++) {
                    Object.keys(xdata[i]).forEach((key) => validKeys.includes(key) || delete xdata[i][key]);
                }
                $el.trigger("lookup.afterRequest", [$el, o.data, xdata]);
                o.onresult.resolve({ data: updateViewModel($el, sttgs, xdata) });
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (o.error) o.error(jqXHR, textStatus, errorThrown);
                o.onresult.resolve(null);
            }
        };
        $.ajax(ajaxReq);
        return o.onresult;
    };
    function updateViewModel(el, sttgs, xdata) {
        let curShowMore = sttgs.data.hideSimple;
        sttgs.data.Items.splice(0, sttgs.data.Items.length);
        let mval = sttgs.ismultiselect && sttgs.value ? sttgs.value.split(sttgs.valueSeparator) : [sttgs.value];
        if (!sttgs.value) mval = [];

        xdata.forEach(function (dx, dxi) {
            dx.title = dx.title ? dx.title : dx.value;
            dx.imageurl = dx.imageurl;
            dx.imagename = dx.title;
            dx.icon = "";
            dx.isChecked = mval.includes(dx.value);
            dx.controlName = sttgs.meta.controlname;
            dx.editorType = sttgs.ismultiselect ? "checkbox" : "radio";
        });

        XPortal.Utils.updateKendoObj(sttgs.data, {
            total: xdata.total,
            count: sttgs.data.hideDetail ? sttgs.psize : xdata.length,
            noItems: xdata.total < 1,
           // hideStatic: true,
            hideDynamic: false,
            showCountOf: xdata.total > sttgs.psize,
            Items: curShowMore ? xdata : [],
            Top: xdata.slice(0, sttgs.psize),
            hideDetail: !curShowMore, hideSimple: curShowMore,
            hideSMore: curShowMore || xdata.total <= sttgs.psize,
            hideSLess: !curShowMore || xdata.total <= sttgs.psize
        });
        return xdata;
    };
    return self;
}());
